import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import createSagaMiddleware from 'redux-saga';

import { PAGE_ERROR_HREF, redirectToErrorPage } from 'shared/constants/errorPages';
import { combineReducers } from './combineReducers';
import { loadState, saveState } from './localStorage';
import { startSagas } from './startSagas';
import { rootEpic } from './rootEpic';

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const epicMiddleware = createEpicMiddleware();
  const persistedState = loadState();
  const store =
    process.env.NODE_ENV === 'production'
      ? createStore(
          combineReducers,
          persistedState,
          applyMiddleware(sagaMiddleware, epicMiddleware),
        )
      : createStore(
          combineReducers,
          persistedState,
          composeWithDevTools(applyMiddleware(sagaMiddleware, epicMiddleware)),
        );

  store.subscribe(() => {
    const { data, type } = store.getState().auth;
    saveState(data && { ...data }, type);
  });

  epicMiddleware.run(rootEpic);

  sagaMiddleware
    .run(startSagas)
    .toPromise()
    .catch(() => {
      redirectToErrorPage(PAGE_ERROR_HREF);
    });

  return { ...store };
};

export { configureStore };
